import React from "react";
import "./Section1.css";
import Section1Image from "../../../../../assets/images/taxreturnssrsec1-img1.png";
import Section1Dots from "../../../../../assets/images/aboutus-dots.png";
const Section1 = () => {
  return (
    <div className="taxreturnssrsec1_section">
      <img
        src={Section1Dots}
        alt=""
        className="taxreturnssrsec1__section_dots"
      />
      <div className="taxreturnssrsec1__section_left">
        <img
          src={Section1Image}
          alt=""
          className="taxreturnssrsec1__section_img"
        />
      </div>
      <div className="taxreturnssrsec1__section_right">
        <div className="taxreturnssrsec1__secleft_description">
          <p>
            Preparing your own income tax return can be a task that leaves you
            with more questions than answers. There is no substitute for the
            knowledge and understanding that a licensed, taxreturnssrsec1 tax
            professional can provide and so we are here to help.
          </p>
          <p>
            Serene Tax is dedicated and a registered tax filing company with
            electronic return originator (ERO) with IRS by circular 230 of IRS
            rules. Tax return process is carried out by our professionals such
            as CPA’s and EA’s who holds Preparer Tax Identification Number
            (PTIN).
          </p>
          <p>
            We evaluate how significant changes in base pay, bonus compensation,
            commissions or stock options may affect taxes, and recommend steps
            that can reduce that liability.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Section1;
